
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credits",
      function () {
        return require("private-next-pages/credits.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credits"])
      });
    }
  